// extracted by mini-css-extract-plugin
export default {"button":"ButtonDownload_button__oZm1G","button__icon":"ButtonDownload_button__icon__I1DGz","button__icon_disabled":"ButtonDownload_button__icon_disabled__CGnnk"};